import { useEffect, useState } from 'react';

import { useStableCallback } from '@hooks/useStableCallback';
import { ComponentEnhancer, TypeOfPropsFor } from '@utils/types';

const ImageWithFallback: ComponentEnhancer<{
  fallbackImage?: string;
  src: string;
}> = ({
  Component,
  src,
  fallbackImage = '/static/images/setur-static.jpg',
  ...props
}) => {
  const [imrSrc, setImgSrc] = useState(src);
  const onError = useStableCallback(() => setImgSrc(fallbackImage));

  useEffect(() => {
    if (src === imrSrc) return;

    setImgSrc(src);
  }, [src]);

  return (
    <Component
      {...(props as TypeOfPropsFor<typeof Component>)}
      src={imrSrc}
      onError={onError}
    />
  );
};

export default ImageWithFallback;
